export default "__VITE_ASSET__BPhPGJ27__"